import React from "react";
import { useTranslation } from "react-i18next";
import { FormControl, Select, MenuItem, Box, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { updateUser } from "../../Utility/API";
import { endPoints } from "../../constant/Environment";
import { setLoginData } from "../../redux/Reducers/AuthReducer/authSplice";

const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
    const IsLoginData = useSelector((state) => state.auth.IsLoginData);
  const [language, setLanguage] = React.useState(IsLoginData?.language || i18n.language);

  const dispatch = useDispatch();
  // console.log("IsLoginData", IsLoginData);

  // Sync language when user's saved language preference is loaded
  React.useEffect(() => {
    if (IsLoginData?.language && IsLoginData.language !== language) {
      setLanguage(IsLoginData.language);
      i18n.changeLanguage(IsLoginData.language);
      localStorage.setItem("language", IsLoginData.language);
    }
  }, [IsLoginData?.language]);

  const handleLanguageChange = async (event) => {
    const selectedLanguage = event.target.value;
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    // Optionally store in localStorage for persistence
    localStorage.setItem("language", selectedLanguage);

    // The whole redux store is persisted, so the reload below would otherwise
    // rehydrate the *previous* language and this switcher would show the wrong
    // selection while the UI renders the new one. Update it optimistically.
    if (IsLoginData?.idUser) {
      dispatch(
        setLoginData({
          user: { ...IsLoginData, language: selectedLanguage },
          isAuthenticated: true,
        })
      );
    }

    // No page reload: RouteList re-keys the routed subtree on i18n.language,
    // which remounts the current screen so its data re-fetches with the new
    // Accept-Language header. The app shell and redux state stay intact.

    try {
      // Update language preference on backend if user is logged in
      if (IsLoginData?.idUser) {
        await updateUser(endPoints.api.UPDATE_LANGUAGE, {
          language: selectedLanguage,
          idUser: IsLoginData.idUser,
        });
      }
    } catch (error) {
      console.error("Failed to update language preference:", error);
    }
  };

  const selectedLang =
    languages.find((lang) => lang.code === language) || languages[0];

  return (
    <Box>
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <Select
          value={language}
          onChange={handleLanguageChange}
          displayEmpty
          renderValue={() => (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <span style={{ fontSize: "1.2rem" }}>{selectedLang.flag}</span>
              <Typography variant="body2">{selectedLang.name}</Typography>
            </Box>
          )}
          sx={{
            color: "white",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255, 255, 255, 0.5)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
            "& .MuiSvgIcon-root": {
              color: "white",
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <span style={{ fontSize: "1.2rem" }}>{lang.flag}</span>
                <Typography>{lang.name}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSwitcher;
